const QTY_AMOUNT_WEIGHT_SUFFIX = /(qty|quantity|amount|weight)$/i;
const QTY_AMOUNT_WEIGHT = /(qty|quantity|amount|weight)/i;

export function isQtyAmountOrWeightColumn(colDef) {
  const field = String(colDef?.field || '').replace(/[\s_-]/g, '');
  const header = String(colDef?.headerName || '').replace(/[\s_-]/g, '');
  const types = Array.isArray(colDef?.type) ? colDef.type : [colDef?.type];
  const isNumericColumn = types.some(type => String(type).toLowerCase() === 'numericcolumn');
  return (
    QTY_AMOUNT_WEIGHT_SUFFIX.test(field)
    || QTY_AMOUNT_WEIGHT_SUFFIX.test(header)
    || (isNumericColumn && (QTY_AMOUNT_WEIGHT.test(field) || QTY_AMOUNT_WEIGHT.test(header)))
  );
}

export function parseAgGridNumber(value, oldValue, precision = 3) {
  if (value === null || value === undefined || String(value).trim() === '') return null;
  const number = Number(String(value).replace(/,/g, '').trim());
  if (!Number.isFinite(number)) return oldValue ?? null;
  const decimals = Number.isInteger(precision) && precision >= 0 ? precision : 3;
  return number.toFixed(decimals);
}
